// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { PersonalDataListComponent } from 'src/app/modules/personal-data/pages/personal-data-list/personal-data-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: PersonalDataListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadPropertiesList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class PersonalDataRoutingModule { }
